<script lang="ts">
  import { fade } from "svelte/transition";
  import Icon from "$lib/components/Icon/Icon.svelte";
  import Typography from "$lib/components/Typography/Typography.svelte";

  export let label = "";
  export let selectedItem = "";
  export let dropdownOpen = false;
  export let disabled = false;
  export let capitalised = false;
  export let showInput = true;
  export let rounded = false;

  export let surfaceBackground = false;
</script>

<style lang="scss">
  .dropdown {
    &--wrapper {
      display: flex;
      flex-direction: column;
      position: relative;
      width: 100%;
    }
    &--input {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      border: 1px solid $on-surface-10;
      padding: 13px 16px;
      cursor: pointer;

      &__rounded {
        border-radius: 24px;
        border: 1px solid rgba(0, 0, 0, 0.2);
      }

      &__surface {
        background: $surface;
        text-wrap-mode: nowrap;
      }

      &__disabled {
        cursor: default;
      }

      &__capitalised {
        text-transform: capitalize;
      }
    }

    &--options {
      position: absolute;
      top: 52px;
      width: 100%;
      background-color: $surface;
      z-index: 10;
      border: 1px solid $on-surface-10;
      border-top: none;
      max-height: 265px;
      overflow: auto;

      &__rounded {
        border-bottom-right-radius: 24px;
        border-bottom-left-radius: 24px;
      }
    }

    &--padding {
      height: 26px;
      width: 100%;
      position: absolute;
      top: 26px;
      width: 100%;
      z-index: 10;
      border-left: 1px solid rgba(0, 0, 0, 0.1);
      border-right: 1px solid rgba(0, 0, 0, 0.1);
      background-color: transparent;
    }

    &--options-no-input {
      position: absolute;
      width: 100%;
      background-color: $surface;
      z-index: 10;
      border: 1px solid $on-surface-10;
      border-top: none;
      max-height: 265px;
      overflow: auto;
    }
  }

  @media screen and (max-height: 625px) {
    .dropdown {
      &--options {
        max-height: 25vh;
      }
    }
  }
</style>

{#if disabled}
  <div class="dropdown--wrapper">
    <div
      class={`dropdown--input dropdown--input__disabled ${
        capitalised ? "dropdown--input__capitalised" : ""
      } ${rounded ? "dropdown--input__rounded" : ""}`}
    >
      <Typography
        component="span"
        theme={selectedItem ? "on-background" : "on-surface-30"}
      >
        {selectedItem && capitalised
          ? selectedItem.toLowerCase()
          : selectedItem
            ? selectedItem
            : label}
      </Typography>
      <Icon icon="expand_more" color="var(--on-surface-10)" />
    </div>
  </div>
{:else}
  <!-- svelte-ignore a11y-no-static-element-interactions -->
  <div
    class="dropdown--wrapper"
    on:mouseleave={() =>
      showInput ? (dropdownOpen = false) : (dropdownOpen = true)}
  >
    {#if showInput}
      <div
        class={`dropdown--input ${rounded ? "dropdown--input__rounded" : ""} ${
          capitalised ? "dropdown--input__capitalised" : ""
        } ${surfaceBackground ? "dropdown--input__surface" : ""}`}
        role="listbox"
        aria-label={label}
        tabindex="0"
        on:click={() => (dropdownOpen = !dropdownOpen)}
        on:keydown={() => (dropdownOpen = !dropdownOpen)}
      >
        <Typography
          component="span"
          theme={selectedItem ? "on-background" : "on-surface-30"}
          role="option"
        >
          {selectedItem && capitalised
            ? selectedItem.toLowerCase()
            : selectedItem
              ? selectedItem
              : label}
        </Typography>
        <Icon
          icon={`${dropdownOpen === true ? "expand_less" : "expand_more"}`}
        />
      </div>
    {/if}

    {#if rounded && dropdownOpen}
      <div class="dropdown--padding" transition:fade={{ duration: 300 }} />
    {/if}

    {#if dropdownOpen}
      <!-- svelte-ignore a11y-no-static-element-interactions -->
      <div
        class={`dropdown--options${showInput ? "" : "-no-input"} ${
          rounded ? "dropdown--options__rounded" : ""
        }`}
        on:click={() => (dropdownOpen = false)}
        on:keydown={() => (dropdownOpen = false)}
        transition:fade={{ duration: 300 }}
      >
        <slot />
      </div>
    {/if}
  </div>
{/if}
